import api from './api';

const userService = {
  // Obtener todos los usuarios
  getUsers: async () => {
    try {
      const response = await api.get('/api/users');
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Error al obtener usuarios';
    }
  },

  // Obtener un usuario por ID
  getUser: async (userId) => {
    try {
      const response = await api.get(`/api/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Error al obtener usuario';
    }
  },

  // Crear usuario
  createUser: async (userData) => {
    try {
      const response = await api.post('/api/users', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Error al crear usuario';
    }
  },

  // Actualizar usuario
  updateUser: async (userId, userData) => {
    try {
      const response = await api.put(`/api/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Error al actualizar usuario';
    }
  },

  // Desactivar usuario
  deleteUser: async (userId) => {
    try {
      await api.delete(`/api/users/${userId}`);
      return true;
    } catch (error) {
      throw error.response?.data?.detail || 'Error al desactivar usuario';
    }
  },

  // Resetear contraseña
  resetPassword: async (userId, newPassword) => {
    try {
      const response = await api.post(`/api/users/${userId}/reset-password`, {
        new_password: newPassword
      });
      return response.data;
    } catch (error) {
      throw error.response?.data?.detail || 'Error al resetear contraseña';
    }
  },
};

export default userService;